import loadTailwindBlocks from './tailwind'

export default (editor, opts = {}) => {
  loadTailwindBlocks(editor, opts)
}
